<template>
    <div class="toggle-container" v-bind:id="'accordion' + flight.id">
        <div class="panel">
            <div class="panel-collapse collapse" v-bind:id="'acc' + flight.id">
                <div class="panel-content" style="padding-top: 0px; padding-left: 15px;">
                    <hr>
                    <h4 class="box-title">{{ taxesandfees[getCurrentLocale] }}:</h4>
                    <br /><br />
                    <div class="" style="padding: 0px; padding-right: 10px; margin-bottom: 0px; width:50%;">
                        <ul class="" style="margin-bottom: 0px; font-size: 0.8333em;">
                            <li class="skin-color uppercase">{{ airfare[getCurrentLocale] }}: <span class="pull-right">{{ Number(flight.prcs[0].amnt) | rndAmntRUAFWZ }}</span></li>
                            <li class="skin-color uppercase">{{ airporttaxes[getCurrentLocale] }}: <span class="pull-right">{{ flight.prcs[0].tax.air | rndAmntRUAFWZ }}</span></li>
                            <li class="skin-color uppercase">{{ aviationtax[getCurrentLocale] }}: <span class="pull-right">{{ flight.prcs[0].tax.avia | rndAmntRUAFWZ }}</span></li>
                            <li class="skin-color uppercase">{{ kerosenesurcharge[getCurrentLocale] }}: <span class="pull-right">{{ flight.prcs[0].tax.fuel | rndAmntRUAFWZ }}</span></li>
                            <li class="skin-color uppercase">{{ securitycharges[getCurrentLocale] }}: <span class="pull-right">{{ flight.prcs[0].tax.sec | rndAmntRUAFWZ }}</span></li>
                            <li class="skin-color uppercase">{{ servicecharges[getCurrentLocale] }}: <span class="pull-right">{{ flight.prcs[0].tax.srvc | rndAmntRUAFWZ }}</span></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';

    import moment from 'moment';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['flight', 'flightdirection', 'modulo'],
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* Data */
        data: function() {

            return {
                // ----------------------------------------
                taxesandfees: {
                    en: 'Taxes and Fees',
                    de: 'Steuern und Gebühren'
                },
                airfare: {
                    en: 'Airfare',
                    de: 'Flugpreis'
                },
                airporttaxes: {
                    en: 'Airport taxes',
                    de: 'Flughafengebühren'
                },
                aviationtax: {
                    en: 'Aviation tax',
                    de: 'Luftverkehrssteuer'
                },
                kerosenesurcharge: {
                    en: 'Kerosene surcharge',
                    de: 'Kerosinzuschlag'
                },
                securitycharges: {
                    en: 'Security charges',
                    de: 'Sicherheitsgebühren'
                },
                servicecharges: {
                    en: 'Service charges',
                    de: 'Servicegebühren'
                },
            };

        }, // eo data
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eo computed
        /* <<< ****************************************************************/

    };
</script>

<style scoped>

    .tab-container .tab-content .tab-pane {
        padding: 0px;
    }
    .tab-container .tab-content {
        background: none;
    }
    .tab-container .tab-content .tab-pane .row {
        margin-bottom: 1px;
    }
    .pricing-table {
        padding: 0px;
        padding-top: 15px;
        padding-bottom: 0px;
        background: none;
    }
    .pricing-table {
        padding: 0px;
        padding-top: 15px;
        padding-bottom: 0px;
        background: none;
    }


    .tab-container.style1 ul.tabs li.active > a, .tab-container.style1 ul.tabs li:hover > a {
        color: #fff;
        background: #ec008b;
        position: relative;
    }
    .tab-container.style1 ul.tabs.srvcs li.active_rebooking > a, .tab-container.style1 ul.tabs.srvcs li:hover > a {
        color: #fff;
        background: #fdb714;
        position: relative;
    }
    .tab-container.style1 ul.tabs.srvcs li.active_rebooking > a:after, .tab-container.style1 ul.tabs.srvcs li:hover > a:after {
        position: absolute;
        bottom: -5px;
        left: 50%;
        margin-left: -10px;
        border-top: 5px solid #fdb714;
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        content: "";
    }

    .icon-check3 {
        position: relative;
        padding-right: 30px !important;
        padding-left: 0 !important;
        overflow: hidden;
    }
    .icon-check3:after {
        content: "";
        position: absolute;
        top: 0;
        right: 10px;
        width: 30px;
        height: 100%;
        background: url(/res/images/icon/icon-check.png) no-repeat center center #4A6E89;
    }


    .topDistance {
        margin-top: 25px;
    }


    a.button:hover {
        background: #fdb714;
    }
</style>


// WEBPACK FOOTER //
// src/components/shared/flightsearch/components/fsr/TaxesAndFees.vue